module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-analytic-4.d1e17c11.svg";